module.exports = __webpack_public_path__ + "img/customers-icon-35906.90234ccd.png";